
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/winter-tyres",
      function () {
        return require("private-next-pages/tyres/winter-tyres.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/winter-tyres"])
      });
    }
  